<template>
  <el-card>
    <div slot="header">
      <h1 class="has-operation">
        <span>延保管理</span>
      </h1>
      <div class="header-index-content"></div>
    </div>

    <el-form inline :model="query" class="filter-form">
      <el-form-item label="申请单号:">
        <el-input v-model="query.applyNumber" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="手机号:">
        <el-input v-model="query.mobile" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="序列号:">
        <el-input v-model="query.serialNumber" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="query.type" clearable placeholder="请选择">
          <el-option
            v-for="item in $enums.warrantyType.getList()"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryCollection">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="showDialog">导出延保单</el-button>
      </el-form-item>
    </el-form>

    <el-table class="table block"
              :data="collection"
              v-loading="loading"
              row-key="id">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="table-expand">
            <el-form-item label="型号">
              <span>{{ props.row.serialModel }}</span>
            </el-form-item>
            <el-form-item label="购买地区">
              <span>{{ props.row.region }}</span>
            </el-form-item>
            <el-form-item label="开票时间">
              <span>{{ props.row.invoiceDate }}</span>
            </el-form-item>
            <el-form-item label="生日">
              <span>{{ props.row.birthday }}</span>
            </el-form-item>
            <el-form-item label="购买渠道">
              <span>{{ props.row.source ? props.row.source : '-' }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column prop="id" label="序号" />
      <el-table-column prop="applyNumber" label="申请单号" />
      <el-table-column label="姓名（ID）">
        <template slot-scope="scope">
          {{scope.row.name}} ({{scope.row && scope.row.user_info ? scope.row.user_info.systemUserId : '-'}})
        </template>
      </el-table-column>
      <el-table-column label="申请人手机号">
        <template slot-scope="scope">
          {{scope.row.mobile}}
          <i class="el-icon-copy-document" @click="copy(scope.row.mobile)"></i>
        </template>
      </el-table-column>
      <el-table-column prop="serialNumber" label="产品序列号" />
      <el-table-column prop="number" label="类型" :formatter="formatType"/>
      <el-table-column prop="createdAt" label="申请时间" />
      <el-table-column prop="shippingName" label="出货先名" />
      <el-table-column prop="jdeNo" label="JDE订单No" />

      <el-table-column label="是否标记" width="150">
        <template slot-scope="{ row }">
          <el-switch @change="(val)=>changeIsMark(val,row)" :value="!!row.isMark"></el-switch>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center">
        <template slot-scope="{row}">
          <el-link @click="handleDel(row)" type="danger">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" :pagination="pagination" :changed="queryCollection" />
    <el-input id="selectMobile" v-model="selectMobile" style="opacity: 0;"/>

    <el-dialog title="请选择导出时间" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker type="date" placeholder="开始时间" v-model="form.startTime"
                          :picker-options="pickerStartOptions"
                          style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item  label="结束时间" prop="endTime">
          <el-date-picker type="date" placeholder="结束时间" v-model="form.endTime"
                          :picker-options="pickerOptions"
                          style="width: 100%;"></el-date-picker>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="exportWarranty">确 定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>

  import { createNamespacedHelpers } from 'vuex'
  const { mapGetters } = createNamespacedHelpers('warranties')
  export default {
    data() {
      return {
        query: {
          applyNumber : '',
          serialNumber : '',
          mobile : '',
          type: '',
        },
        form: {
          startTime: '',
          endTime: '',
        },
        dialogFormVisible: false,
        loading: true,
        selectMobile: '',
        rules: {
          startTime : [{ required: true, message: '请输入开始日期', trigger: 'blur' }],
          endTime : [{ required: true, message: '请输入结束日期', trigger: 'blur' }],
        }
      }
    },
    computed: {
      ...mapGetters(['collection', 'total', 'pagination']),
      pickerOptions() {
        return {
          disabledDate: (time) => {
            return time.getTime() < Date.parse(this.form.startTime);
          }
        }
      },
      pickerStartOptions() {
        return {
          disabledDate: (time) => {
            return time.getTime() > Date.parse(this.form.endTime);
          }
        }
      },
    },
    methods: {
      handleDel(row){
        this.$confirm('确定删除该记录吗？','提示').then(async ()=>{
          await this.$store.dispatch('warranties/remove',{id:row.id})
          await this.queryCollection()
          this.$message.success('操作成功')
        })
      },

      async changeIsMark(val, row) {
        await this.$store.dispatch('warranties/update',{id:row.id, isMark:val})
        await this.queryCollection()
        this.$message.success('操作成功')
      },

      async queryCollection({ pagination = { limit: 20 } } = {}) {
        let query = {
          ...this.query,
        }

        try {
          this.loading = true
          await this.$store.dispatch('warranties/collection', { query, pagination })
        } finally {
          this.loading = false
        }
      },
      formatType (warranty) {
        return this.$enums.warrantyType.label(warranty.type)
      },
      copy(mobile) {
        this.selectMobile = mobile
        this.$nextTick(()=> {
          var copyObj = document.getElementById("selectMobile")
          copyObj.select() // 选择对象
          document.execCommand("Copy") // 执行浏览器复制命令
          var selection = window.getSelection()
          selection.removeAllRanges()
        })
        this.$message.success('电话号码复制成功')
      },
      showDialog() {
        this.dialogFormVisible = true
      },
      async exportWarranty() {
        await this.$formHelper.promisedValidate(this.$refs.form)
        let query = {start : this.form.startTime, end : this.form.endTime}

        query.start = new Date(Date.parse(query.start) + 8 * 3600 * 1000)
        query.start = query.start.toJSON().substr(0, 19).replace('T', ' ')

        query.end = new Date(Date.parse(query.end) + 8 * 3600 * 1000)
        query.end = query.end.toJSON().substr(0, 19).replace('T', ' ')
        this.$linkHelper.redirect('warranty-export', query)
      }
    },
    async mounted() {
      await this.queryCollection()
      this.loading = false
    }
  }
</script>

<style lang="less" scoped>
  .table-expand {
    font-size: 0;
  }
  .table-expand /deep/label {
    width: 100px;
    color: #99a9bf;
  }
  .table-expand /deep/.el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }

  .el-icon-copy-document {
    font-size: 18px;
    cursor: pointer;
    color: #1f69c0;
  }
</style>
